<app-date-controls (dateChange)="onChangedDate($event)"></app-date-controls>

<div class="my-3">
    <app-weather-map [date]="date"></app-weather-map>
    <div class="mt-6">
        <app-satellite [date]="date"></app-satellite>
        <app-rader [date]="date"></app-rader>
        <app-sat-and-radar [date]="date"></app-sat-and-radar>
    </div>
</div>